import { FC } from "react";
import { useTranslation } from "react-i18next";
import { TextAreaInput } from "../../../../../components/controls/inputs/BaseInput";
import { BaseModalWindow } from "../../../../../components/modalWindows/BaseModalWindow";
import { SupplierDataCheckAction } from "../../../../../libs/coreapi-dto/dirs/supplierDataCheck";

interface IProducerPriceValidationModalProps {
    visible: boolean;
    header: string;
    warning?: string;
    items: string;
    question?: string;
    action: SupplierDataCheckAction;
    onConfirm?: () => void;
    onCancel: () => void;
    largeTextArea?: boolean;
    textAreaInputStyle?: React.CSSProperties;
}

const ProducerPriceValidationModal: FC<IProducerPriceValidationModalProps> = (props) => {
    const { t } = useTranslation();

    const handleCancel = () => {
        props.onCancel();
    };

    const handleConfirm = () => {
        props.onConfirm?.();
    };

    const isWarn = props.action === "WARN";
    const isLock = props.action === "LOCK";

    const modalStyle = isWarn 
        ? { backgroundColor: "rgb(255, 204, 51, 0.2)", color: "#333333" }
        : { backgroundColor: "rgb(204, 51, 51, 0.2)", color: "#333333" };

    return (
        <BaseModalWindow
            header={props.header}
            ok={{
                onClick: handleConfirm,
                title: props.question ? t("general.accept") : t("general.ok"),
                hidden: !props.onConfirm
            } }
            cancel={{
                onClick: handleCancel,
                title: isLock ? t("general.ok") : t("general.cancel")
            }}
        >
            {props.warning && (
                <label style={{ whiteSpace: 'pre-line' }}>
                    {props.warning}
                </label>
            )}
            <TextAreaInput
                largeTextArea={props.largeTextArea}
                value={props.items}
                style={props.textAreaInputStyle || modalStyle}
                readonly
            />
            {props.question && (
                <>
                    <br />
                    <b>{props.question}</b>
                </>
            )}
        </BaseModalWindow>
    );
};

export default ProducerPriceValidationModal